<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1 class="toc-title">Contents</h1>
<ol class="none" epub:type="list">
<li class="toc-front" id="cover"><span href="#/cover" title="Link target outside of Sample">COVER</span></li>
<li class="toc-front" id="titlepage"><span href="#/titlepage" title="Link target outside of Sample">TITLE PAGE</span></li>
<li class="toc-front" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">COPYRIGHT</span></li>
<li class="toc-front" id="toc-dedication"><a href="#/dedication">DEDICATION</a></li>
<li class="toc-front" id="toc-preface003"><a href="#/preface003">AUTHOR NOTE</a></li>
<li class="toc-chapter1" id="toc-chapter001"><a href="#/chapter001">CHAPTER 1: POMEGRANATES FULL AND FINE</a></li>
<li class="toc-chapter" id="toc-chapter002"><a href="#/chapter002">CHAPTER 2: IT RUNS IN THE FAMILY</a></li>
<li class="toc-chapter" id="toc-chapter003"><span href="#/chapter003" title="Link target outside of Sample">CHAPTER 3: A HOST OF FURIOUS FANCIES</span></li>
<li class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">CHAPTER 4: DEATH IN THE FAMILY</span></li>
<li class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">CHAPTER 5: MY SISTER’S KEEPER</span></li>
<li class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">CHAPTER 6: THE LUNATICS HAVE TAKEN OVER THE ASYLUM</span></li>
<li class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">CHAPTER 7: STRAYING LATE AND LONELY</span></li>
<li class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">CHAPTER 8: IN THE COMPANY OF COURTESANS</span></li>
<li class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">CHAPTER 9: I AM NOT AN ANIMAL</span></li>
<li class="toc-chapter" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">CHAPTER 10: CURIOUSER AND CURIOUSER</span></li>
<li class="toc-chapter" id="toc-chapter011"><span href="#/chapter011" title="Link target outside of Sample">CHAPTER 11: SURPRISES, LIKE MISFORTUNES, SELDOM COME ALONE</span></li>
<li class="toc-chapter" id="toc-chapter012"><span href="#/chapter012" title="Link target outside of Sample">CHAPTER 12: ADVERSITY IS THE FIRST PATH TO TRUTH</span></li>
<li class="toc-chapter" id="toc-chapter013"><span href="#/chapter013" title="Link target outside of Sample">CHAPTER 13: THE PURE AND SIMPLE TRUTH IS RARELY PURE AND NEVER SIMPLE</span></li>
<li class="toc-chapter" id="toc-chapter014"><span href="#/chapter014" title="Link target outside of Sample">CHAPTER 14: NOT SINGLE SPIES BUT AS BATTALIONS</span></li>
<li class="toc-chapter" id="toc-chapter015"><span href="#/chapter015" title="Link target outside of Sample">CHAPTER 15: I BEHELD THE WRETCH – THE MISERABLE MONSTER WHOM I HAD CREATED</span></li>
<li class="toc-chapter" id="toc-chapter016"><span href="#/chapter016" title="Link target outside of Sample">CHAPTER 16: MORALITY, LIKE ART, MEANS DRAWING A LINE SOME PLACE</span></li>
<li class="toc-chapter" id="toc-chapter017"><span href="#/chapter017" title="Link target outside of Sample">CHAPTER 17: TO THE DEAD WE OWE ONLY THE TRUTH</span></li>
<li class="toc-chapter" id="toc-chapter018"><span href="#/chapter018" title="Link target outside of Sample">CHAPTER 18: TRUTH IS THE BEGINNING OF EVERY GOOD THING</span></li>
<li class="toc-chapter" id="toc-chapter019"><span href="#/chapter019" title="Link target outside of Sample">UNDERSTANDING THE ARISTOCRACY</span></li>
<li class="toc-chapter1" id="toc-acknowledgements"><span href="#/acknowledgements" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></li>
<li class="toc-chapter" id="toc-appendix001"><span href="#/appendix001" title="Link target outside of Sample">EXTRAS</span>
<ol class="none">
<li class="toc-chapter2" id="toc-personblurb"><span href="#/personblurb" title="Link target outside of Sample">MEET THE AUTHOR</span></li>
<li class="toc-chapter2" id="toc-teaser001"><span href="#/teaser001" title="Link target outside of Sample">A PREVIEW OF <em>THE QUEEN IS DEAD</em></span></li>
<li class="toc-chapter2" id="toc-teaser002"><span href="#/teaser002" title="Link target outside of Sample">A PREVIEW OF <em>STRANGE PRACTICE</em></span></li>
</ol></li>
<li class="toc-chapter" id="toc-ad-card"><a href="#/adcard">BY KATE LOCKE</a></li>
<li class="toc-chapter" id="toc-glossary"><span href="#/glossary" title="Link target outside of Sample">GLOSSARY</span></li>
<li class="toc-chapter" id="Newsletters"><span href="#/newsletterOrbit" title="Link target outside of Sample">ORBIT NEWSLETTER</span></li>
</ol>
</nav>
<nav class="hidden-tag" epub:type="landmarks" hidden="hidden">
<h1>Navigation</h1>
<ol class="none" epub:type="list">
<li><a epub:type="bodymatter" href="#/chapter001">Begin Reading</a></li>
<li><a epub:type="toc" href="#/toc">Table of Contents</a></li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4eda7c65